import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldType, } from '@dossierhq/core';
import { Column, Text } from '@dossierhq/design';
import { Fragment, useContext } from 'react';
import { PublishedDossierContext } from '../../contexts/PublishedDossierContext.js';
import { FieldDisplay } from './FieldDisplay.js';
export function ComponentFieldDisplay({ className, value }) {
    const { schema } = useContext(PublishedDossierContext);
    if (!schema || !value) {
        return null;
    }
    const { type } = value;
    const componentSpec = schema.getComponentTypeSpecification(type);
    if (!componentSpec) {
        return _jsx("div", { children: "Error" });
    }
    return (_jsxs(Column, { className: className, gap: 1, children: [_jsx(Text, { textStyle: "body2", marginBottom: 0, children: type }), componentSpec.fields.map((valueFieldSpec) => {
                const fieldDisplay = (_jsx(FieldDisplay, { fieldSpec: valueFieldSpec, value: value[valueFieldSpec.name] }));
                return (_jsxs(Fragment, { children: [_jsx(Text, { textStyle: "subtitle1", marginBottom: 0, children: valueFieldSpec.name }), valueFieldSpec.type === FieldType.Component ? (_jsx("div", { className: "nested-value-item-indentation", children: fieldDisplay })) : (fieldDisplay)] }, valueFieldSpec.name));
            })] }));
}
//# sourceMappingURL=ComponentFieldDisplay.js.map